import React from 'react'
import PropTypes from 'prop-types'

import { Form, Tag, Empty, Typography } from 'antd'

import Avatar from '../../../../components/Avatar'
import LocationMap from '../../../Heroes/components/PickLocation'

export const BinDetails = ({ data }) => {
  return (
    <Form layout="vertical">
      <Form.Item label="Cover">
        {data && data.avatar && data.avatar.url ? (
          <Avatar size={128} src={data.avatar.url} />
        ) : (
          <Empty style={{ marginTop: 16 }} />
        )}
      </Form.Item>

      <Form.Item label="Name (ชื่อถัง)" style={{}}>
        <Typography.Text color="secondary">{data.name}</Typography.Text>
      </Form.Item>

      <Form.Item label="Address (ที่อยุ่)">
        <Typography.Text color="secondary">{data.address}</Typography.Text>
      </Form.Item>

      <Form.Item label="Description (คำอธิบายสถานที่ตั้ง)">
        <Typography.Text color="secondary">{data.desc}</Typography.Text>
      </Form.Item>

      <Form.Item label="Locations (สถานที่ตั้ง)">
        {data && data.locations && data.locations.length > 0 ? (
          <LocationMap draggable={false} locations={data.locations} />
        ) : (
          <div>No locations</div>
        )}
      </Form.Item>

      <Form.Item label="Material (วัสดุรีไซเคิลที่รับ)">
        {data.products &&
          data.products.map((product, index) => (
            <Typography.Text color="secondary" key={`product-${index}`}>
              {index !== 0 && ' , '}
              {product.material.name}
            </Typography.Text>
          ))}
      </Form.Item>

      <Form.Item label="Public (เปิดให้บุคคลทั่วไปทิ้งได้)">
        <Tag color={data.isPublic ? 'green' : 'red'}>
          {data.isPublic ? 'YES' : 'NO'}
        </Tag>
      </Form.Item>

      <Form.Item label="Quick (ทิ้งแบบเร็ว)">
        <Tag color={data.isQuick ? 'green' : 'red'}>
          {data.isQuick ? 'YES' : 'NO'}
        </Tag>
      </Form.Item>

      <Form.Item label="Tool (มีอุปการณ์ช่วนในการคัดแยก)">
        <Tag color={data.hasTool ? 'green' : 'red'}>
          {data.hasTool ? 'YES' : 'NO'}
        </Tag>
      </Form.Item>
    </Form>
  )
}

BinDetails.propTypes = {
  data: PropTypes.object.isRequired
}

export default BinDetails
